import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import Initial from './Initial';
import Trivia from './Trivia';
import Question from './Question';
import Hint from './Hint';
import Correct from './Correct';
import Incorrect from './Incorrect';
import LastInitial from './LastInitial';
import LastTrivia from './LastTrivia';
import Ending from './Ending';
import Fin from './Fin';
import Timeup from './Timeup';

function Interface({ allQuestions, root, dir }) {
  const query = useQuery();
  const [scene, changeScene] = useState(0); //0:初期画面 1:出題 2:ヒント 3:間違え 4:正解 5:最終問題開始画面 6:最終画面1 7:最終画面2 8:最終画面3 9:タイムアップ
  const [level, setLevel] = useState(query.get('level') ? query.get('level') - 1 : '0');
  const [number, setnumber] = useState(query.get('number') ? query.get('number') - 1 : '0');
  const [currentQuestion, changeCurrentQuestion] = useState(allQuestions[level].questions[number]);

  useEffect(() => {
    root.addEventListener('open', (e) => {
      //ポップアップ開く
      //1-1の時はフェードイン
      if (e.detail.number == 1) root.dataset.fade = 'fade';
      root.dataset.status = 'show';
      const level = e.detail.level ? e.detail.level - 1 : 0;
      const number = e.detail.number ? e.detail.number - 1 : 0;
      changeScene(0);
      setLevel(level);
      setnumber(number);
      changeCurrentQuestion(allQuestions[level].questions[number]);
    });
    root.addEventListener('close', (e) => {
      //ポップアップ閉じる
      root.dataset.fade = '';
      root.dataset.status = 'hide';
    });
    root.addEventListener('change', (e) => {
      //シーン変更
      const scene = e.detail.scene ? e.detail.scene : 0;
      changeScene(scene);
    });
    root.addEventListener('timeup', (e) => {
      //タイムアップ
      root.dataset.fade = '';
      root.dataset.status = 'show';
      changeScene(9);
    });
    // componentWillUnmount
    return () => {
      root.removeEventListener('open');
      root.removeEventListener('close');
      root.removeEventListener('change');
      root.removeEventListener('timeup');
    };
  }, []);

  return (
    <>
      {(scene == 0 || scene > 9) && number == 0 && (
        //1問目の初期画面(謎解きスタート)
        <Initial
          dir={dir}
          text={currentQuestion.initial}
          root={root}
          level={level}
          number={number}
          onClick={() => changeScene(1)}
          //
        />
      )}
      {(scene == 0 || scene > 9) && number != 0 && (
        //1問目以外の初期画面(豆知識)
        <Trivia
          dir={dir}
          text={currentQuestion.initial}
          root={root}
          level={level}
          number={number}
          isLast={currentQuestion.last}
          onClick={() => {
            if (!currentQuestion.last) {
              changeScene(1);
            } else {
              changeScene(5);
            }
          }}
          //
        />
      )}
      {scene == 1 && (
        //出題画面
        <Question
          dir={dir}
          currentQuestion={currentQuestion}
          level={level}
          number={number}
          root={root}
          onClick={(sceneNumber) => changeScene(sceneNumber)}
          //
        />
      )}
      {scene == 2 && (
        //ヒント
        <Hint
          dir={dir}
          text={currentQuestion.hint}
          level={level}
          number={number}
          hintImg={currentQuestion.hintImg}
          onClick={(sceneNumber) => changeScene(sceneNumber)}
          //
        />
      )}
      {scene == 3 && (
        //不正解
        <Incorrect
          dir={dir}
          onClick={(sceneNumber) => changeScene(sceneNumber)}
          //
        />
      )}
      {scene == 4 && (
        //正解
        <Correct
          dir={dir}
          answer={currentQuestion.answer}
          level={level}
          number={number}
          root={root}
          isLast={currentQuestion.last}
          correct={currentQuestion.correct}
          correctNumber={currentQuestion.choicesnumber ? currentQuestion.choicesnumber[currentQuestion.correct] : false}
          correctNote={currentQuestion.correctNote}
          correctText={currentQuestion.choices[currentQuestion.correct]}
          onClick={(sceneNumber) => changeScene(sceneNumber)}
          //
        />
      )}
      {scene == 5 && (
        //最終問題開始画面
        <LastInitial
          dir={dir}
          text={currentQuestion.initial}
          root={root}
          level={level}
          number={number}
          onClick={() => changeScene(1)}
          //
        />
      )}
      {scene == 6 && (
        //最終画面1
        <LastTrivia
          dir={dir}
          text={currentQuestion.lastTxt}
          root={root}
          level={level}
          number={number}
          onClick={() => {
            changeScene(7);
          }}
          //
        />
      )}
      {scene == 7 && (
        //最終画面2
        <Ending
          dir={dir}
          root={root}
          level={level}
          number={number}
          onClick={() => changeScene(8)}
          //
        />
      )}
      {scene == 8 && (
        //最終画面3
        <Fin
          dir={dir}
          root={root}
          level={level}
          number={number}
          //
        />
      )}
      {scene == 9 && (
        //タイムアップ
        <Timeup
          dir={dir}
          root={root}
          level={level}
          number={number}
          //
        />
      )}
    </>
  );
}

export default Interface;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
